"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoGuideWrapper = exports.ListItem = exports.List = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.List = (0, styled_1.default)('ul') `
  list-style-type: none;
  margin: 0 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')};
  padding: 0;
  & li:not(:last-of-type) {
    padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
`;
exports.ListItem = (0, styled_1.default)('li') `
  display: grid;
  grid-template-columns: 125px auto;
  grid-auto-rows: 40px;
  column-gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  align-items: center;
`;
exports.NoGuideWrapper = (0, styled_1.default)('div') `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  & button {
    border-width: 0;
    background-color: transparent;
  }
`;
//# sourceMappingURL=PracticeGroups.styles.js.map